import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getRegistrationTypeOptions, getRegistrationTypeOptionsByScope } from '../../api/codelist/codeListsSlice';

const RegistrationTypeSelect = ({
  name,
  label = 'Registration Type',
  control,
  errors,
  readOnly = false,
  disabled,
  customerType,
  onChange,
  overrideOptions,
}) => {
  const registrationTypeOptions = useSelector(getRegistrationTypeOptions);
  const getRegistrationTypeOptionsByScopeSelector = useSelector(getRegistrationTypeOptionsByScope);

  const optionsToUse = useMemo(() => {
    if (overrideOptions) return overrideOptions;
    if (!customerType) return registrationTypeOptions;
    const scope = customerType === 'BUSINESS' ? 'B2B' : 'B2C';
    return getRegistrationTypeOptionsByScopeSelector(scope);
  }, [overrideOptions, customerType, registrationTypeOptions, getRegistrationTypeOptionsByScopeSelector]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id={name}
            data-testid={`${name}-select`}
            options={optionsToUse}
            readOnly={readOnly}
            getOptionLabel={(option) =>
              option.label ? (option.code ? `${option.label} (${option.code})` : option.label) : ''
            }
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid={`${name}-input`}
                label={label}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option.code === value?.code}
            onChange={(_, value) => {
              field.onChange(value);
              onChange?.(value);
            }}
            value={field.value || null} // handle default value
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default RegistrationTypeSelect;
